<template>
  <v-content class="candidate page">
    <can I="read" a="Candidate">
      <v-container>
        <v-toolbar flat class="transparent">
          <v-breadcrumbs class="pl-0"
            :items="[{ exact: true, text: 'Admin', to: '/dashboard' },
                     { exact: true, text: 'Candidates', to: '/candidates' },
                     { exact: true, text: $route.params.id, to: `/candidates/${$route.params.id}` }]">
            <v-icon slot="divider">mdi-chevron-right</v-icon>
          </v-breadcrumbs>

          <v-spacer />

          <v-btn small flat fab @click="refresh">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <CopyButton />
        </v-toolbar>

        <can I="edit" a="Candidate" v-if="editing">
          <Edit @refresh="refresh" @update="update" @cancel="cancel" />
        </can>
        <Show v-else @refresh="refresh" @destroy="destroy" @edit="editing = true" />
      </v-container>
    </can>
  </v-content>
</template>

<script>
// Components
import Show from '@/components/candidates/Show'
import Edit from '@/components/candidates/Edit'

// Vue Component
export default {
  components: {
    Show,
    Edit,
  },
  data() {
    return { editing: false }
  },
  computed: {
    candidate() {
      return this.$store.getters['admin/candidates/find'](this.$route.params.id)
    },
  },
  created() {
    this.$store.dispatch('admin/candidates/fetch', this.$route.params.id)
  },
  methods: {
    refresh() {
      return this.$store.dispatch('admin/candidates/fetch', this.$route.params.id)
    },
    cancel() {
      this.refresh().then(() => (this.editing = false))
    },
    update() {
      this.$store.dispatch('admin/candidates/update', this.candidate).then(() => {
        if (this.candidate.errors) {
          this.$store.commit('snackbar', {
            text: 'There was a problem updating the candidate',
            type: 'error',
          })
        } else {
          this.$store.commit('snackbar', {
            text: 'Candidate was updated successfully',
            type: 'success',
          })
          this.editing = false
        }
      })
    },
    destroy() {
      this.$store.dispatch('admin/candidates/destroy', this.candidate.id).then(
        () => {
          // Success
          this.$store.commit('snackbar', { text: 'Candidate deleted', type: 'success' })
          this.$router.push('/candidates')
        },
        // Failure
        () =>
          this.$store.commit('snackbar', {
            text: 'There was a problem deleting the candidate',
            type: 'error',
          })
      )
    },
  },
}
</script>
